export const ACCOUNT_DELETION_REASONS = [
  "NO_LONGER_USING",
  "LACK_OF_FEATURES",
  "BUGS_AND_ERRORS",
  "USING_ANOTHER_SERVICE",
  "OTHER",
] as const;

export type AccountDeletionReason = (typeof ACCOUNT_DELETION_REASONS)[number];

export const ACCOUNT_DELETION_REASON_LABEL: Record<AccountDeletionReason, string> = {
  NO_LONGER_USING: "더 이상 사용하지 않음",
  LACK_OF_FEATURES: "원하는 기능이 없음",
  BUGS_AND_ERRORS: "오류·버그가 잦음",
  USING_ANOTHER_SERVICE: "다른 서비스 사용",
  OTHER: "기타",
};

export interface AccountDeletionSurveyItem {
  surveyId: string;
  userId: string;
  userEmail: string;
  userCreatedAt: string;
  withdrawnAt: string;
  reason: AccountDeletionReason;
  detail: string | null;
}

export interface AccountDeletionReasonCount {
  reason: AccountDeletionReason;
  count: number;
}
